import React, { useEffect, useState } from "react";
import axios from "axios";
import utils from "../../utils";
import {
  Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography,
  Select, MenuItem, FormControl, InputLabel, CircularProgress, Stack, Grid, Dialog, DialogTitle, DialogContent,
  DialogContentText, DialogActions, Divider, Checkbox, FormControlLabel, IconButton, Tooltip, Badge,
} from '@mui/material';
import {
  PrintOutlined as PrintOutlinedIcon, Delete as DeleteIcon, Info as InfoIcon,
  Add as AddIcon, Sort as SortIcon, Sync as SyncIcon, People as PeopleIcon,
  AttachFileOutlined as FileIcon, Upload as UploadIcon, Visibility as VisibilityIcon,
  Download as DownloadIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TabellaPresenze = () => {

  const now = new Date();
  // fino al 20 metti di default il mese prima
  if (now.getDate() <= 20) {
    now.setMonth(now.getMonth() - 1);
  }

  // Calcola il giorno della settimana per il 1° del mese selezionato
  const calcolaPrimoGiornoSettimana = (anno, mese) => {
    const giorno = new Date(anno, mese, 0).getDay();
    return giorno === 0 ? 7 : giorno; // Se è domenica, ritorna 7 (che rappresenterà lunedì nel tuo sistema), altrimenti ritorna il giorno così com'è
  };

  const giorniInMeseX = (anno) => {
    return [
      31, anno % 4 ? 28 : 29, 31, 30, 31, 30,
      31, 31, 30, 31, 30, 31
    ];
  }

  const calcolaPasqua = (anno) => {
    const a = anno % 19;
    const b = Math.floor(anno / 100);
    const c = anno % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(anno, month - 1, day);
  };

  const getFestivoInfo = (anno, mese, giorno) => {
    const festivi = [
      { mese: 0, giorno: 1, nome: 'Capodanno' },
      { mese: 0, giorno: 6, nome: 'Epifania' },
      { mese: 3, giorno: 25, nome: 'Festa della Liberazione' },
      { mese: 4, giorno: 1, nome: 'Festa del Lavoro' },
      { mese: 5, giorno: 2, nome: 'Festa della Repubblica' },
      { mese: 7, giorno: 15, nome: 'Ferragosto' },
      { mese: 10, giorno: 1, nome: 'Ognissanti' },
      { mese: 11, giorno: 8, nome: 'Immacolata Concezione' },
      { mese: 11, giorno: 25, nome: 'Natale' },
      { mese: 11, giorno: 26, nome: 'Santo Stefano' },
    ];

    // Aggiungi la Pasqua
    const pasqua = calcolaPasqua(anno);
    festivi.push({ mese: pasqua.getMonth(), giorno: pasqua.getDate(), nome: 'Pasqua' });
    // Pasquetta
    pasqua.setDate(pasqua.getDate() + 1);
    festivi.push({ mese: pasqua.getMonth(), giorno: pasqua.getDate(), nome: 'Pasquetta' });

    const festivo = festivi.find(f => f.mese === mese && f.giorno === giorno);
    return {
      isFestivo: !!festivo,
      nomeFestivo: festivo ? festivo.nome : null
    };
  };

  const [loading, setLoading] = useState(true);
  const [statusMessage, setStatusMessage] = useState("");
  const [isMaster, setIsMaster] = useState(false);
  const [azienda, setAzienda] = useState(null);
  const [aziende, setAziende] = useState([]);
  const [isError, setError] = useState(true);
  const [anno, setAnno] = useState(now.getFullYear());
  const [mese, setMese] = useState(now.getMonth()); // 0 rappresenta gennaio
  const [numGiorniMese, setNumGiorniMese] = useState(giorniInMeseX(now.getFullYear())[now.getMonth()]);
  const [dipendenti, setDipendenti] = useState(['Dipendente 1']);
  const [tabVisualizzata, setTabVisualizzata] = useState(0);
  const [ruoli, setRuoli] = useState(['']);
  const [note, setNote] = useState(['']);
  const [orari, setOrari] = useState(['']);
  const [primoGiornoSettimana, setPrimoGiornoSettimana] =
    useState(calcolaPrimoGiornoSettimana(now.getFullYear(), now.getMonth()));
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedIndexToRemove, setSelectedIndexToRemove] = useState(null);

  const [oraEntrata, setOraEntrata] = useState('');
  const [oraUscita, setOraUscita] = useState('');
  const [oraInizioPausa, setOraInizioPausa] = useState('');
  const [oraFinePausa, setOraFinePausa] = useState('');
  const [oreTotali, setOreTotali] = useState('');

  const [selectedDays, setSelectedDays] = useState([]);
  const [hours, setHours] = useState('');

  // Dialog Autocompile ore
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [openInfoDialog, setOpenInfoDialog] = useState(false);

  // nuova gestione files
  const [presenzeFiles, setPresenzeFiles] = useState([]);
  const [openFilesDialog, setOpenFilesDialog] = useState(false);

  // mappa dipendenti id => nome
  const [dipendentiMap, setDipendentiMap] = useState({});
  const [ruoliMap, setRuoliMap] = useState({});
  const [centriCostoMap, setCentriCostoMap] = useState({});

  // nuova versione con dipendenti attiva da maggio 2025
  const isV2 = () => {
    return anno > 2025 || (anno == 2025 && mese > 3);
  }

  const navigate = useNavigate();

  const initialState = {
    oreLavorate: Array(numGiorniMese).fill(''),
    notturno: Array(numGiorniMese).fill(''),
    straordinarioNotturno: Array(numGiorniMese).fill(''),
    festivo: Array(numGiorniMese).fill(''),
    straordinari: Array(numGiorniMese).fill(''),
    ferie: Array(numGiorniMese).fill(''),
    festivitaGoduta: Array(numGiorniMese).fill(''),
    permessi: Array(numGiorniMese).fill(''),
    assenze: Array(numGiorniMese).fill(''),
    malattia: Array(numGiorniMese).fill(''),
    infortunio: Array(numGiorniMese).fill(''),
    maternita: Array(numGiorniMese).fill(''),
    oreViaggio: Array(numGiorniMese).fill(''),
    flessibilita: Array(numGiorniMese).fill(''),
    altriEventi: Array(numGiorniMese).fill(''),
  };

  const [presenze, setPresenze] = useState([initialState]);
  const [presenzeInviate, setPresenzeInviate] = useState(false);

  const mesi = [
    'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
    'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
  ];

  const giorniSettimana = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];

  useEffect(() => {
    start();
  }, []);

  const start = async () => {
    try {
      const res = await axios.get("/api/me", {
        headers: utils.getAuthHeaders(),
        validateStatus: () => true,
      });

      if (res.status === 200) {
        const { success, error, me } = res.data;
        if (success) {
          if (me.op) {
            window.location.href = "/op";
          } else if (me.is_master) {
            setIsMaster(true);
            loadAziende();
          } else {
            loadData(now.getMonth(), now.getFullYear());
            loadDipendenti("");
          }
        } else if (error) {
          setStatusMessage(error);
          setLoading(false);
        }
        return;
      }
    } catch (error) {
      setStatusMessage(error);
    }

    setLoading(false);

    if (process.env.REACT_APP_ENV !== "test") {
      window.location.href = "/login?backto=%2Fcli%2Fpresenze";
    }
  }

  const loadDipendenti = async (id) => {
    try {
      const res = await axios.get('/api/dipendenti?eliminati=true&id=' + id, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        const map = {};
        for (const dip of res.data.dipendenti) {
          map[dip.id] = `${dip.cognome} ${dip.nome}`;
        }
        setDipendentiMap(map);
        const map2 = {};
        for (const dip of res.data.dipendenti) {
          map2[dip.id] = dip.mansione;
        }
        setRuoliMap(map2);
        const map3 = {};
        for (const dip of res.data.dipendenti) {
          map3[dip.id] = dip.centro_costo; // supponendo che il campo sia `centro_costo`
        }
        setCentriCostoMap(map3);

      } else {
        setError(true);
        setStatusMessage(error);
      }
    } catch (error) {
      setError(true);
      setStatusMessage(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
  };

  const loadAziende = async () => {
    try {
      const res = await axios.get(`/api/sottoaziende`, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setAziende(res.data.aziende);
      } else {
        setError(true);
        setStatusMessage(error);
      }
    } catch (error) {
      setError(true);
      setStatusMessage(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
    setLoading(false);
    if (process.env.REACT_APP_ENV == "test") {
      setAziende([{ id: 1, nome: 'Azienda Test' }]);
    }
  }

  const loadData = async (m, y, id = null) => {
    try {
      const res = await axios.get(`/api/presenzecliente?m=${m}&y=${y}` + (isMaster ? `&id=${id}` : ""), {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        if (res.data.presenze) {
          setPresenze(res.data.presenze);
          setDipendenti(res.data.dipendenti);
          setOrari(res.data.orari);
          setRuoli(res.data.ruoli);
          setNote(res.data.note);
          setPresenzeFiles(res.data.files || []);
          setPresenzeInviate(res.data.inviato);
        }
      } else {
        setError(true);
        setStatusMessage(error);
      }
    } catch (error) {
      setError(true);
      setStatusMessage(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
    setLoading(false);
  }

  const aggiornaDipendenti = async () => {
    setLoading(true);
    const payload = { year: anno, month: mese, id: azienda };
    try {
      const res = await axios.post(`/api/aggiornadipendentipresenze`, payload, {
        headers: utils.getAuthHeaders()
      });
      const { success, error } = res.data;
      if (success) {
        setError(false);
        setStatusMessage("Dipendenti aggiornati con successo.");
        return loadData(mese, anno, azienda);
      } else {
        setError(true);
        setStatusMessage(error);
      }
    } catch (error) {
      setError(true);
      setStatusMessage(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
    setLoading(false);
  }

  const confirm = async (invia) => {
    setOpenConfirm(false);
    setStatusMessage("");
    setLoading(true);
    try {
      const json = { month: mese, year: anno, data: { presenze, dipendenti, ruoli, orari, note }, id: isMaster ? azienda : undefined };

      const payload = new FormData();

      payload.append("data", JSON.stringify(json));

      const res = await axios.post(`/api/${invia ? 'inviapresenze' : 'aggiornapresenze'}`, payload, {
        headers: {
          ...utils.getAuthHeaders(),
          "Content-Type": "multipart/form-data",
        },
      });
      const { success, error } = res.data;
      if (success) {
        setError(false);
        if (invia) {
          setStatusMessage("Presenze inviate con successo.");
          setPresenzeInviate(true);
        } else {
          setStatusMessage("Presenze aggiornate con successo.");
        }
      } else {
        setError(true);
        setStatusMessage(error);
      }
    } catch (error) {
      setError(true);
      setStatusMessage(
        "Si è verificato un errore imprevisto sul nostro server."
      );
      console.log(error);
    }
    setLoading(false);
  }

  // Funz per il caricamento dei file
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("data", JSON.stringify({
        name: file.name, mese, anno
      }));

      const res = await axios.post("/api/caricafilepresenze", formData, {
        headers: {
          ...utils.getAuthHeaders(),
          "Content-Type": "multipart/form-data",
        },
      });

      const { success, error, fileId } = res.data;
      if (success) {
        const allFiles = [...presenzeFiles, { id: fileId, name: file.name, date: new Date().toISOString() }]
        setPresenzeFiles(allFiles);
      } else {
        setError(true);
        setStatusMessage(error);
      }
    } catch (err) {
      setError(true);
      setStatusMessage("Errore durante il caricamento del file.");
      console.error(err);
    }
  };

  const handleFileDelete = async (fileId) => {
    try {
      const res = await axios.post(`/api/eliminafilepresenze`, { id: fileId, mese, anno }, {
        headers: utils.getAuthHeaders(),
      });

      const { success, error } = res.data;
      if (success) {
        const allFiles = presenzeFiles.filter(f => f.id != fileId);
        setPresenzeFiles(allFiles);
      } else {
        setError(true);
        setStatusMessage(error);
      }
    } catch (err) {
      setError(true);
      setStatusMessage("Errore durante il caricamento del file.");
      console.error(err);
    }
  };

  const sumOre = (ore) => {
    let totMinuti = 0
    let totOre = 0;
    for (const ora of ore) {
      if (!ora) {
        continue;
      }
      const spl = ora.split('.');
      totOre += parseInt(spl[0]);
      if (parseInt(spl[1])) {
        if (spl[1] === '5') {
          totMinuti += 30;
        } else {
          totMinuti += parseInt(spl[1].padEnd(2, '0'));
        }
      }
    }
    return `${totOre + Math.floor(totMinuti / 60)}:${(totMinuti % 60).toString().padStart(2, '0')}`
  }

  // Funzione per cambiare il mese selezionato
  const handleMeseChange = (event) => {
    setLoading(true);
    setStatusMessage("");
    const nuovoMese = event.target.value;
    setMese(nuovoMese);
    const giorniInMese = giorniInMeseX(anno)[nuovoMese];
    setNumGiorniMese(giorniInMese);
    const primoGiornoSett = calcolaPrimoGiornoSettimana(anno, nuovoMese);
    setPrimoGiornoSettimana(primoGiornoSett);
    setPresenze((prevState) => prevState.map((entry) => ({
      ...entry,
      oreLavorate: Array(giorniInMese).fill(''),
      notturno: Array(giorniInMese).fill(''),
      straordinarioNotturno: Array(giorniInMese).fill(''),
      festivo: Array(giorniInMese).fill(''),
      straordinari: Array(giorniInMese).fill(''),
      ferie: Array(giorniInMese).fill(''),
      festivitaGoduta: Array(giorniInMese).fill(''),
      permessi: Array(giorniInMese).fill(''),
      assenze: Array(giorniInMese).fill(''),
      malattia: Array(giorniInMese).fill(''),
      infortunio: Array(giorniInMese).fill(''),
      maternita: Array(giorniInMese).fill(''),
      oreViaggio: Array(giorniInMese).fill(''),
      flessibilita: Array(giorniInMese).fill(''),
      altriEventi: Array(giorniInMese).fill(''),
    })));
    setNote(['']);
    loadData(nuovoMese, anno, azienda);
  };

  const handleAnnoChange = (event) => {
    setLoading(true);
    setStatusMessage("");
    const nuovoAnno = event.target.value;
    setAnno(nuovoAnno);
    const giorniInMese = giorniInMeseX(nuovoAnno)[mese];
    setNumGiorniMese(giorniInMese);
    const primoGiornoSett = calcolaPrimoGiornoSettimana(nuovoAnno, mese);
    setPrimoGiornoSettimana(primoGiornoSett);
    setPresenze((prevState) => prevState.map((entry) => ({
      ...entry,
      oreLavorate: Array(giorniInMese).fill(''),
      notturno: Array(giorniInMese).fill(''),
      straordinarioNotturno: Array(giorniInMese).fill(''),
      festivo: Array(giorniInMese).fill(''),
      straordinari: Array(giorniInMese).fill(''),
      ferie: Array(giorniInMese).fill(''),
      festivitaGoduta: Array(giorniInMese).fill(''),
      permessi: Array(giorniInMese).fill(''),
      assenze: Array(giorniInMese).fill(''),
      malattia: Array(giorniInMese).fill(''),
      infortunio: Array(giorniInMese).fill(''),
      maternita: Array(giorniInMese).fill(''),
      oreViaggio: Array(giorniInMese).fill(''),
      flessibilita: Array(giorniInMese).fill(''),
      altriEventi: Array(giorniInMese).fill(''),
    })));
    setNote(['']);
    loadData(mese, nuovoAnno, azienda);
  };

  // Funzione per cambiare l'azienda selezionata
  const handleAziendaChange = (event) => {
    const nuovaAzienda = Number(event.target.value);
    setLoading(true);
    setStatusMessage("");
    setAzienda(nuovaAzienda);
    const giorniInMese = giorniInMeseX(anno)[mese];
    setPresenze((prevState) => prevState.map((entry) => ({
      ...entry,
      oreLavorate: Array(giorniInMese).fill(''),
      notturno: Array(giorniInMese).fill(''),
      straordinarioNotturno: Array(giorniInMese).fill(''),
      festivo: Array(giorniInMese).fill(''),
      straordinari: Array(giorniInMese).fill(''),
      ferie: Array(giorniInMese).fill(''),
      festivitaGoduta: Array(giorniInMese).fill(''),
      permessi: Array(giorniInMese).fill(''),
      assenze: Array(giorniInMese).fill(''),
      malattia: Array(giorniInMese).fill(''),
      infortunio: Array(giorniInMese).fill(''),
      maternita: Array(giorniInMese).fill(''),
      oreViaggio: Array(giorniInMese).fill(''),
      flessibilita: Array(giorniInMese).fill(''),
      altriEventi: Array(giorniInMese).fill(''),
    })));
    setDipendenti(['']);
    setOrari(['']);
    setRuoli(['']);
    setNote(['']);
    loadDipendenti(nuovaAzienda);
    loadData(mese, anno, nuovaAzienda);
  };

  const handleTabVisualizzataChange = (event) => {
    setTabVisualizzata(Number(event.target.value));
  }

  // Funzione per aggiungere una tabella per un nuovo dipendente
  const aggiungiTabellaDipendente = () => {
    const currentLength = dipendenti.length;
    setDipendenti((prevState) => [...prevState, `Dipendente ${prevState.length + 1}`]);
    setOrari((prevState) => [...prevState, '']);
    setRuoli((prevState) => [...prevState, '']);
    setNote((prevState) => [...prevState, '']);
    setPresenze((prevState) => [...prevState, initialState]);
    setTimeout(() => setTabVisualizzata(currentLength), 100);
  };

  // Funzione per rimuovere una tabella di un dipendente
  const rimuoviTabellaDipendente = (dipendenteIndex) => {
    if (dipendenteIndex > 0) {
      setTabVisualizzata(dipendenteIndex - 1);
    }
    const nuoviDipendenti = [...dipendenti];
    nuoviDipendenti.splice(dipendenteIndex, 1);
    setDipendenti(nuoviDipendenti);

    const nuoviOrari = [...orari];
    nuoviOrari.splice(dipendenteIndex, 1);
    setOrari(nuoviOrari);

    const nuoviRuoli = [...ruoli];
    nuoviRuoli.splice(dipendenteIndex, 1);
    setRuoli(nuoviRuoli);

    const nuoveNote = [...note];
    nuoveNote.splice(dipendenteIndex, 1);
    setNote(nuoveNote);

    const nuovePresenze = [...presenze];
    nuovePresenze.splice(dipendenteIndex, 1);
    setPresenze(nuovePresenze);
  };

  // Funzione per aprire il dialog elimina tab dipendente
  const openRemoveDialog = (dipendenteIndex) => {
    setSelectedIndexToRemove(dipendenteIndex);
    setOpenDialog(true);
  };
  const closeRemoveDialog = () => {
    setOpenDialog(false);
  };
  // Gestore dell'evento onClick per il pulsante "Elimina"
  const handleRemoveButtonClick = (dipendenteIndex) => {
    openRemoveDialog(dipendenteIndex);
  };

  // Funzione per aggiornare le informazioni di un dipendente
  const handleDipendenteChange = (event, dipendenteIndex, tipo, giorno) => {
    const value = event.target.value.replace(',', '.').replace(':', '.');
    if (value === '') {
      const nuovaPresenza = [...presenze];
      nuovaPresenza[dipendenteIndex][tipo][giorno - 1] = '';
      setPresenze(nuovaPresenza);
      return;
    }

    const numeroValue = parseFloat(value);
    if (isNaN(numeroValue)) {
      return;
    }

    const splittedValue = value.split('.');
    let numero = parseInt(splittedValue[0]).toString();
    if (splittedValue.length > 1) {
      const decimalPart = splittedValue[1].substring(0, 2);
      numero = `${numero}.${decimalPart}`;
    }

    const nuovaPresenza = [...presenze];
    nuovaPresenza[dipendenteIndex][tipo][giorno - 1] = value;
    setPresenze(nuovaPresenza);
  };

  const ordinaDipendenti = () => {
    const indices = dipendenti
      .map((value, index) => ({ value, index }))
      .sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)
      .map(item => item.index);

    setPresenze(indices.map(i => presenze[i]));
    setRuoli(indices.map(i => ruoli[i]));
    setOrari(indices.map(i => orari[i]));
    setNote(indices.map(i => note[i]));
    setDipendenti(indices.map(i => dipendenti[i]));
    setTabVisualizzata(0);
  }

  // Funzione per aggiornare il nome di un dipendente
  const handleNomeDipendenteChange = (event, dipendenteIndex) => {
    const nuovoNome = event.target.value;
    const nuoviDipendenti = [...dipendenti];
    nuoviDipendenti[dipendenteIndex] = nuovoNome;
    setDipendenti(nuoviDipendenti);
  };

  // Funzione per aggiornare il ruolo di un dipendente
  const handleRuoloChange = (event, dipendenteIndex) => {
    const nuovoNome = event.target.value;
    const nuoviRuoli = [...ruoli];
    nuoviRuoli[dipendenteIndex] = nuovoNome;
    setRuoli(nuoviRuoli);
  };

  // Funzione per aggiornare l'orario di un dipendente
  const handleOrarioChange = (event, dipendenteIndex) => {
    const nuovoNome = event.target.value;
    const nuoviOrari = [...orari];
    nuoviOrari[dipendenteIndex] = nuovoNome;
    setOrari(nuoviOrari);
  };

  // Funzione per aggiornare il ruolo di un dipendente
  const handleNoteChange = (event, dipendenteIndex) => {
    const nuovoNome = event.target.value;
    const nuoveNote = [...note];
    nuoveNote[dipendenteIndex] = nuovoNome;
    setNote(nuoveNote);
  };

  // Funzione per calcolare il totale delle ore di un dipendente per un giorno specifico
  const calcolaTotaleGiornaliero = (idx, giorno) => {
    return sumOre(
      ['oreLavorate', 'notturno', 'straordinarioNotturno', 'festivo',
        'straordinari', 'oreViaggio', 'flessibilita', 'altriEventi']
        .map(tipo => presenze[idx][tipo][giorno - 1]));
  }

  // Funzione per calcolare il totale delle ore di un dipendente
  const calcolaTotale = (idx) => {
    return sumOre(Array.from({ length: numGiorniMese }, (_, i) => i + 1)
      .map(giorno => calcolaTotaleGiornaliero(idx, giorno).replace(':', '.')));
  }

  // Funzione per formattare i dati della tabella in un formato stampabile
  const formatDataForPrint = () => {
    let dataToPrint = `
  <style>
    @page { size: A4 landscape; margin: 10mm; }
    body { font-family: Arial, sans-serif; font-size: 6px; margin: 0; padding: 0; }
    table { width: 100%; border-collapse: collapse; margin-bottom: 5px; }
    th, td { border: 1px solid black; padding: 2px; text-align: center; }
    th { background-color: #f2f2f2; font-size: 8px; }
    tr:nth-child(even) { background-color: #f9f9f9; }
    .header { text-align: center; font-size: 10px; font-weight: bold; margin-bottom: 10px; }
    .grid-container { display: grid; grid-template-columns: repeat(4, 1fr); gap: 5px; margin-bottom: 5px; }
    .grid-item { font-size: 8px; padding: 5px; border-bottom: 1px solid #ddd; }
    .notes { font-size: 10px; margin-top: 12px; }
    .divider { border-top: 1px solid #333; margin: 10px 0; }
    .page-break { page-break-after: always; }
    .small-font { font-size: 8px; } /* Classe per ridurre la dimensione del carattere */
  </style>
  `;

    // Aggiungi dati della tabella per ogni dipendente
    dipendenti.forEach((dip, idx) => {
      let totalOreLavorate = sumOre(presenze[idx].oreLavorate);
      let totalNotturno = sumOre(presenze[idx].notturno);
      let totalStraordinari = sumOre(presenze[idx].straordinari);
      let totalStraordinarioNotturno = sumOre(presenze[idx].straordinarioNotturno);
      let totalFestivo = sumOre(presenze[idx].festivo);
      let totalFerie = sumOre(presenze[idx].ferie);
      let totalFestivitaGoduta = sumOre(presenze[idx].festivitaGoduta);
      let totalPermessi = sumOre(presenze[idx].permessi);
      let totalMalattie = sumOre(presenze[idx].malattia);
      let totalOreViaggio = sumOre(presenze[idx].oreViaggio);
      let totalFlessibilita = sumOre(presenze[idx].flessibilita);
      let totalAltriEventi = sumOre(presenze[idx].altriEventi);
      let totalAssenze = sumOre(presenze[idx].assenze);
      let totalInfortunio = sumOre(presenze[idx].infortunio);
      let totalMaternita = sumOre(presenze[idx].maternita);

      // Inizia un nuovo foglio per ogni dipendente
      dataToPrint += `<div class="page">`;
      dataToPrint += `<div class="grid-container">
            <div class="grid-item"><b>Dipendente:</b> ${isV2() ? dipendentiMap[dip] : dip}</div>
            <div class="grid-item"><b>Mansione:</b> ${isV2() ? ruoliMap[dip] : ruoli[idx]}</div>
            <div class="grid-item"><b>Centro di Costo:</b> ${isV2() ? centriCostoMap[dip] : ''}</div>
            <div class="grid-item"><b>Mese:</b> ${meseToName(mese)}</div>
          </div>`;
      dataToPrint += `<table>`;
      dataToPrint += `<thead>`;
      dataToPrint += `<tr><td colspan="16" style="height: 20px; border: none;"></td></tr>`; // Spazio aggiunto
      dataToPrint += `<tr>
        <th class="small-font" style="width: 6%;">Giorno</th>
        <th style="width: 6%;">Ore Lavorate</th>
        <th style="width: 6%;">Notturno</th>
        <th style="width: 6%;">Straordinari</th>
        <th style="width: 6%;">Straordinario Notturno</th> <!-- Nuova colonna -->
        <th style="width: 6%;">Festivo</th>
        <th style="width: 6%;">Ferie</th>
        <th style="width: 6%;">Fest. Goduta</th>
        <th style="width: 6%;">Permessi</th>
        <th style="width: 6%;">Assenze</th>
        <th style="width: 6%;">Malattia</th>
        <th style="width: 6%;">Infortunio</th>
        <th style="width: 6%;">Maternità</th>
        <th style="width: 6%;">Ore Viaggio</th>
        <th style="width: 6%;">Flessibilità</th> <!-- Nuova colonna -->
        <th style="width: 6%;">Altri Eventi</th>
      </tr>`;
      dataToPrint += `</thead>`;
      dataToPrint += `<tbody>`;

      for (let i = 0; i < numGiorniMese; i++) {
        const data = new Date(anno, mese, i + 1);
        const giornoSettimana = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'][data.getDay()];
        dataToPrint += `<tr>
          <td class="small-font">${i + 1} ${giornoSettimana}</td>
          <td class="small-font">${presenze[idx].oreLavorate[i] || ''}</td>
          <td class="small-font">${presenze[idx].notturno[i] || ''}</td>
          <td class="small-font">${presenze[idx].straordinari[i] || ''}</td>
          <td class="small-font">${presenze[idx].straordinarioNotturno[i] || ''}</td> <!-- Nuova colonna -->
          <td class="small-font">${presenze[idx].festivo[i] || ''}</td>
          <td class="small-font">${presenze[idx].ferie[i] || ''}</td>
          <td class="small-font">${presenze[idx].festivitaGoduta[i] || ''}</td>
          <td class="small-font">${presenze[idx].permessi[i] || ''}</td>
          <td class="small-font">${presenze[idx].assenze[i] || ''}</td>
          <td class="small-font">${presenze[idx].malattia[i] || ''}</td>
          <td class="small-font">${presenze[idx].infortunio[i] || ''}</td>
          <td class="small-font">${presenze[idx].maternita[i] || ''}</td>
          <td class="small-font">${presenze[idx].oreViaggio[i] || ''}</td>
          <td class="small-font">${presenze[idx].flessibilita[i] || ''}</td> <!-- Nuova colonna -->
          <td class="small-font">${presenze[idx].altriEventi[i] || ''}</td>
        </tr>`;
      }

      const totalEffettivo = sumOre([
        ...presenze[idx].oreLavorate,
        ...presenze[idx].straordinari,
        ...presenze[idx].notturno,
        ...presenze[idx].oreViaggio,
        ...presenze[idx].festivo,
        ...presenze[idx].altriEventi,
        ...presenze[idx].straordinarioNotturno,
        ...presenze[idx].flessibilita
      ]);

      dataToPrint += `<tr style="font-weight: bold;">
        <td>Totale</td>
        <td>${totalOreLavorate}</td>
        <td>${totalNotturno}</td>
        <td>${totalStraordinari}</td>
        <td>${totalStraordinarioNotturno}</td>
        <td>${totalFestivo}</td>
        <td>${totalFerie}</td>
        <td>${totalFestivitaGoduta}</td>
        <td>${totalPermessi}</td>
        <td>${totalAssenze}</td>
        <td>${totalMalattie}</td>
        <td>${totalInfortunio}</td>
        <td>${totalMaternita}</td>
        <td>${totalOreViaggio}</td>
        <td>${totalFlessibilita}</td>
        <td>${totalAltriEventi}</td>
      </tr>`;

      dataToPrint += `</tbody>`;
      dataToPrint += `</table>`;

      dataToPrint += `<div class="notes" style="margin-top: 20px;"><b>Totale Effettivo:</b> ${totalEffettivo} ore</div>`;
      dataToPrint += `<div class="notes"><b>Note:</b> ${note[idx]}</div>`;
      dataToPrint += `</div>`;
      dataToPrint += `<div class="page-break"></div>`;
    });

    return dataToPrint;
  };

  // Funzione per convertire il numero del mese in nome del mese
  const meseToName = (mese) => {
    const mesi = [
      'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
      'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
    ];
    return mesi[mese];
  };

  // Funzione per gestire il clic sul pulsante di stampa
  const handleStampaClick = () => {
    const dataToPrint = formatDataForPrint();
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(`<html><head><title>Stampa</title></head><body>${dataToPrint}</body></html>`);
    printWindow.document.close();
    printWindow.print();
  };

  // Funzione per gestire il cambiamento dell'ora di entrata
  const handleChangeOraEntrata = (event) => {
    const { value } = event.target;
    setOraEntrata(value);
    // Aggiorna il totale delle ore
    calculateTotalHours(value, oraUscita, oraInizioPausa, oraFinePausa);
  };

  // Funzione per gestire il cambiamento dell'ora di uscita
  const handleChangeOraUscita = (event) => {
    const { value } = event.target;
    setOraUscita(value);
    // Aggiorna il totale delle ore
    calculateTotalHours(oraEntrata, value, oraInizioPausa, oraFinePausa);
  };

  // Funzione per gestire il cambiamento dell'ora di inizio pausa
  const handleChangeOraInizioPausa = (event) => {
    const { value } = event.target;
    setOraInizioPausa(value);
    // Aggiorna il totale delle ore
    calculateTotalHours(oraEntrata, oraUscita, value, oraFinePausa);
  };

  // Funzione per gestire il cambiamento dell'ora di fine pausa
  const handleChangeOraFinePausa = (event) => {
    const { value } = event.target;
    setOraFinePausa(value);
    // Aggiorna il totale delle ore
    calculateTotalHours(oraEntrata, oraUscita, oraInizioPausa, value);
  };

  // Funzione per calcolare il totale delle ore
  const calculateTotalHours = (entrata, uscita, inizioPausa, finePausa) => {
    // Funzione per convertire orario in minuti dall'inizio della giornata
    const timeToMinutes = (time) => {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    };

    // Converti tutti gli orari in minuti
    const entrataMinuti = entrata ? timeToMinutes(entrata) : 0;
    const uscitaMinuti = uscita ? timeToMinutes(uscita) : 0;
    const inizioPausaMinuti = inizioPausa ? timeToMinutes(inizioPausa) : 0;
    const finePausaMinuti = finePausa ? timeToMinutes(finePausa) : 0;
    // Calcola la durata totale del lavoro escludendo il tempo di pausa
    const minutiLavorativi = uscitaMinuti - entrataMinuti;
    const minutiPausa = finePausaMinuti - inizioPausaMinuti;
    const minutiTotali = minutiLavorativi - minutiPausa;
    // Calcola ore e minuti dal totale dei minuti
    const ore = Math.floor(minutiTotali / 60);
    const minuti = minutiTotali % 60;
    // Formatta il totale delle ore nel formato "HH.MM"
    const oreFormattate = String(ore);
    const minutiFormattati = String(minuti).padStart(2, '0');

    setOreTotali(`${oreFormattate}.${minutiFormattati}`);
  };

  // Gestione Cambio Giorno e Ora Compilazione
  const handleDayChange = (event) => {
    const day = event.target.name;
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleHoursChange = (event) => {
    const value = event.target.value.replace(',', '.').replace(':', '.');
    if (value === '') {
      setHours(value);
      return;
    }

    const numeroValue = parseFloat(value);
    if (isNaN(numeroValue)) {
      return;
    }

    const splittedValue = value.split('.');
    let numero = parseInt(splittedValue[0]).toString();
    if (splittedValue.length > 1) {
      const decimalPart = splittedValue[1].substring(0, 2);
      numero = `${numero}.${decimalPart}`;
    }
    setHours(value);
  };

  // Funzione per compilare le ore in automatico
  const handleFillTimesheet = (dipendenteIndex) => {
    if (!presenze[dipendenteIndex]) {
      console.error(`presenze[${dipendenteIndex}] is undefined`);
      return;
    }

    const newPresenze = [...presenze];
    const numGiorniMese = giorniInMeseX(anno)[mese];

    const dayMap = {
      lun: 'Lun',
      mar: 'Mar',
      mer: 'Mer',
      gio: 'Gio',
      ven: 'Ven',
      sab: 'Sab',
      dom: 'Dom',
    };

    for (let giorno = 1; giorno <= numGiorniMese; giorno++) {
      const date = new Date(anno, mese, giorno);
      const dayOfWeek = date.toLocaleString('it-IT', { weekday: 'short' }).toLowerCase();
      const shortDayOfWeek = dayMap[dayOfWeek];

      if (selectedDays.includes(shortDayOfWeek)) {
        newPresenze[dipendenteIndex].oreLavorate[giorno - 1] = hours.replace(/[,:;]/g, '.');
      }
    }

    setPresenze(newPresenze);
  };

  const handleFillAllTimesheets = () => {
    setConfirmMessage('Compilando per tutti, eventuali singole compilazioni dei dipendenti verranno sovrascritte. Sei sicuro di voler procedere?');
    setOpenConfirmDialog(true);
  };
  const fillAllTimesheets = () => {
    for (let dipendenteIndex = 0; dipendenteIndex < dipendenti.length; dipendenteIndex++) {
      handleFillTimesheet(dipendenteIndex);
    }
  };

  // Funzione per aprire il dialog dell info compilazione ore
  const handleOpenInfoDialog = () => {
    setOpenInfoDialog(true);
  };
  const handleCloseInfoDialog = () => {
    setOpenInfoDialog(false);
  };

  // Controlla eventuali presenze vuote dei dip
  const checkEmptyPresenze = () => {
    const emptyPresenze = [];

    dipendenti.forEach((dipendente, index) => {
      const presenza = presenze[index];
      const isEmpty = Object.values(presenza).every((array) => array.every((value) => value === ''));
      if (isEmpty) {
        emptyPresenze.push(isV2() ? dipendentiMap[dipendente] || '???' : dipendente);
      }
    });

    return emptyPresenze;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      p={1}
      mx="auto"
    >
      <Typography variant="h4" gutterBottom style={{ textAlign: 'center' }}>
        Foglio Presenze
      </Typography>
      <Typography variant="body2" gutterBottom style={{ color: 'gray', fontStyle: 'italic', textAlign: 'center' }}>
        <Box component="span" fontWeight="bold" mr={1}>
          Inviare le presenze Entro il 20 del Mese Successivo.
        </Box>
        Controllare Bene Tutti i Campi Nell'Inserimento dei Dati prima dell'Invio.
      </Typography>

      {/* Paper Azienda Dipendente Mese Anno */}
      <Paper elevation={3} style={{ margin: '4px', width: '90vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box p={1} textAlign="center">
          <Grid container spacing={1} justifyContent="center" alignItems="center" direction="row">

            {isMaster && (
              <Grid item xs={12} sm={6} md="auto" lg="auto">
                <FormControl variant="outlined" size="small" style={{ width: '250px' }}>
                  <InputLabel htmlFor="azienda">Azienda:</InputLabel>
                  <Select
                    id="azienda"
                    value={azienda}
                    onChange={handleAziendaChange}
                    label="Azienda"
                  >
                    {aziende.map(az => (
                      <MenuItem key={az.id} value={az.id}>{az.nome}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {isV2() && <Grid item xs={12} sm={6} md="auto" lg="auto">
              <Tooltip title="Sincronizza con lista dipendenti">
                <IconButton
                  variant="contained"
                  color="primary"
                  onClick={aggiornaDipendenti}
                >
                  <SyncIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Dipendenti">
                <IconButton
                  variant="contained"
                  color="primary"
                  onClick={() => navigate(`../cli/dipendenti`)}
                >
                  <PeopleIcon />
                </IconButton>
              </Tooltip>
            </Grid>}

            <Grid item xs={12} sm={6} md="auto" lg="auto">
              <FormControl variant="outlined" size="small" style={{ width: '250px' }}>
                <InputLabel htmlFor="dipendente">Dipendente:</InputLabel>
                <Select
                  id="dipendente"
                  value={tabVisualizzata}
                  onChange={handleTabVisualizzataChange}
                  label="Dipendente"
                >
                  {dipendenti.map((dip, idx) => (
                    <MenuItem key={idx} value={idx}>{isV2() ? (dipendentiMap[dip] || '???') : dip}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {!isV2() && <Grid item xs={12} sm={6} md="auto" lg="auto">
              <Tooltip title="Ordina">
                <IconButton variant="contained" color="primary" onClick={ordinaDipendenti}>
                  <SortIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Aggiungi Dipendente">
                <IconButton variant="contained" color="success" onClick={aggiungiTabellaDipendente}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Grid>}

            <Grid item xs={12} sm={6} md="auto" lg="auto">
              <FormControl variant="outlined" size="small" style={{ width: '250px' }}>
                <InputLabel htmlFor="mese">Mese:</InputLabel>
                <Select
                  id="mese"
                  value={mese}
                  onChange={handleMeseChange}
                  label="Mese"
                >
                  {mesi.map((mese, index) => (
                    <MenuItem key={index} value={index}>{mese}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md="auto" lg="auto">
              <FormControl variant="outlined" size="small" style={{ width: '250px' }}>
                <InputLabel htmlFor="anno">Anno:</InputLabel>
                <Select
                  id="anno"
                  value={anno}
                  onChange={handleAnnoChange}
                  label="Anno"
                >
                  {Array.from({ length: new Date().getFullYear() - 2022 }, (_, i) => 2024 + i).map((a) => (
                    <MenuItem key={a} value={a}>{a}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md="auto" lg="auto">
              <Tooltip title="Stampa Presenze">
                <IconButton onClick={handleStampaClick} color="dark">
                  <PrintOutlinedIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Allega File">
                <IconButton onClick={() => setOpenFilesDialog(true)} color="dark">
                  <Badge badgeContent={presenzeFiles.length} color="primary">
                    <FileIcon fontSize="medium" />
                  </Badge>
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      </Paper>

      {/* Paper Compilazione ore */}
      <Paper elevation={2} style={{ width: '90vw', marginTop: '10px' }}>
        <Box p={1}>
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            {['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'].map((day, index) => (
              <Grid item key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedDays.includes(day)}
                      onChange={handleDayChange}
                      name={day}
                    />
                  }
                  label={day}
                />
              </Grid>
            ))}
            <Grid item>
              <TextField
                variant="outlined"
                size="small"
                label="Ore"
                value={hours}
                onChange={handleHoursChange}
                style={{ width: '160px' }}
              />
            </Grid>
            <Grid item>
              <Tooltip title="Compila per questo Dipendente">
                <Button disabled={presenzeInviate} variant="contained" color="primary" onClick={() => handleFillTimesheet(tabVisualizzata)}>
                  Compila
                </Button>
              </Tooltip>
            </Grid>

            <Grid item>
              <Tooltip title="Compila per tutti i Dipendenti">
                <Button disabled={presenzeInviate} variant="contained" color="primary" onClick={handleFillAllTimesheets}>
                  Compila Tutti
                </Button>
              </Tooltip>
            </Grid>

            <Grid item>
              <Tooltip title="Guida inserimento ore">
                <IconButton onClick={handleOpenInfoDialog}>
                  <InfoIcon style={{ color: 'orange' }} />
                </IconButton>
              </Tooltip>
            </Grid>

            {/* Dialog per conferma compila tutti */}
            <Dialog
              open={openConfirmDialog}
              onClose={() => setOpenConfirmDialog(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Conferma"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {confirmMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenConfirmDialog(false)} color="primary">
                  Annulla
                </Button>
                <Button onClick={() => { setOpenConfirmDialog(false); fillAllTimesheets(); }} color="primary" autoFocus>
                  Conferma
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>

          {/* Dialog per guida compilazione ore */}
          <Dialog
            open={openInfoDialog}
            onClose={handleCloseInfoDialog}
            aria-labelledby="info-dialog-title"
            aria-describedby="info-dialog-description"
            maxWidth="md"
            fullWidth
          >
            <DialogContent>
              <DialogContentText id="info-dialog-description" style={{ fontStyle: 'italic', color: 'gray' }}>
                <strong>Inserimento Ore:</strong><br />
                Per l'inserimento corretto delle ore, la conversione è in sessantesimi. <br />
                Ad esempio, 1.30 corrisponde a 1 ora e mezza (30 minuti). <br />
                Se inserisci 8.50, significa 8 ore e 50 minuti. <br /><br />

                <strong>Compilazione Ore:</strong><br />
                - Per compilare rapidamente le ore, seleziona i giorni lavorati e inserisci il numero di ore da applicare. <br />
                - Cliccando su <strong>"Compila"</strong>, il sistema compilerà automaticamente tutti i giorni del mese con quell'orario. <br />
                - Se invece clicchi su <strong>"Compila per tutti"</strong>, verranno compilati tutti i dipendenti per quel mese con le stesse ore. <br />
                - In ogni momento è possibile modificare manualmente le ore dei singoli dipendenti. <br /><br />

                <strong>Gestione Dipendenti:</strong><br />
                - Per aggiungere nuovi dipendenti, clicca sull’icona dei dipendenti: si aprirà la pagina dedicata, da cui potrai aggiungere i nominativi che non sono stati inseriti automaticamente dalle pratiche. <br />
                - Tutti i dati aggiuntivi del dipendente, come la mansione o eventuali note, possono essere visualizzati, modificati o integrati dalla stessa lista. <br /><br />

                <strong>Allegati:</strong><br />
                - Puoi allegare documenti utili per i dipendenti e per la gestione delle presenze del mese in corso cliccando sull’icona della graffetta in alto a destra.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseInfoDialog} color="primary">
                Chiudi
              </Button>
            </DialogActions>
          </Dialog>

        </Box>
      </Paper>

      {loading ? (<Stack sx={{ my: 3 }} alignItems="center">
        <CircularProgress disableShrink />
      </Stack>) : (<div>
        {dipendenti.length == 0 ? (<Typography />) : (

          <Paper
            key={tabVisualizzata}
            elevation={3}
            style={{ margin: '16px', width: '90vw' }}
          >
            <Box p={2} textAlign="center">
              <Grid container spacing={2} justifyContent="center">

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    variant="outlined"
                    size="small"
                    label="Cognome e Nome"
                    disabled={presenzeInviate || isV2()}
                    value={isV2() ? (dipendentiMap[dipendenti[tabVisualizzata]] || '???') : dipendenti[tabVisualizzata]}
                    onChange={(e) => handleNomeDipendenteChange(e, tabVisualizzata)}
                    style={{ marginBottom: '6px' }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Tooltip title="Modifica nella lista dipendenti" arrow>
                    <TextField
                      variant="outlined"
                      size="small"
                      label="Mansione"
                      disabled={presenzeInviate || isV2()}
                      value={isV2() ? (ruoliMap[dipendenti[tabVisualizzata]] || '') : ruoli[tabVisualizzata]}
                      onChange={(e) => handleRuoloChange(e, tabVisualizzata)}
                      style={{ marginBottom: '6px' }}
                      fullWidth
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    variant="outlined"
                    size="small"
                    label="Centro di Costo"
                    disabled
                    value={isV2() ? (centriCostoMap[dipendenti[tabVisualizzata]] || '') : ''}
                    style={{ marginBottom: '6px' }}
                    fullWidth
                  />
                </Grid>

                {!isV2() && <Grid item xs={12} sm={6} md={3} lg={3}>
                  <TextField
                    variant="outlined"
                    size="small"
                    label="Orario"
                    disabled={presenzeInviate}
                    value={orari[tabVisualizzata]}
                    onChange={(e) => handleOrarioChange(e, tabVisualizzata)}
                    style={{ marginBottom: '6px' }}
                    fullWidth
                  />
                </Grid>}
                {!isV2() && <Grid item xs={12} sm={6} md={3} sx={{ textAlign: { xs: 'center', md: 'right' } }}>
                  <Tooltip title="Elimina questo Dipendente">
                    <Button
                      variant="contained"
                      onClick={() => handleRemoveButtonClick(tabVisualizzata)}
                      style={{ marginBottom: '6px', backgroundColor: 'red' }}
                    >
                      Elimina
                    </Button>
                  </Tooltip>
                </Grid>}
              </Grid>

              {/* Dialog conferma elimina tab dipendente */}
              <Dialog
                open={openDialog}
                onClose={closeRemoveDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">Conferma Rimozione</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Sei sicuro di voler rimuovere questa tabella?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={closeRemoveDialog} color="primary">
                    Annulla
                  </Button>
                  <Button onClick={() => {
                    rimuoviTabellaDipendente(selectedIndexToRemove);
                    closeRemoveDialog();
                  }} color="primary" autoFocus>
                    Conferma
                  </Button>
                </DialogActions>
              </Dialog>

              <Divider style={{ margin: '12px 0' }} />

              <TableContainer style={{ overflowX: 'auto' }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Giorno</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => {
                        const { isFestivo, nomeFestivo } = getFestivoInfo(anno, mese, giorno);
                        return (
                          <TableCell
                            key={giorno}
                            style={{
                              color: isFestivo
                                ? 'DodgerBlue' // Colore verde scuro per i giorni festivi
                                : giorniSettimana[(primoGiornoSettimana + giorno - 1) % 7] === 'Sab' ||
                                  giorniSettimana[(primoGiornoSettimana + giorno - 1) % 7] === 'Dom'
                                  ? 'orange' // Colore arancione per sabato e domenica
                                  : 'inherit',
                              fontSize: '12px'
                            }}
                          >
                            <Tooltip title={nomeFestivo || ''}>
                              <span>
                                {giorno}
                                <br />
                                {giorniSettimana[(primoGiornoSettimana + giorno - 1) % 7]}
                              </span>
                            </Tooltip>
                          </TableCell>
                        );
                      })}
                      <TableCell>Totale Ore</TableCell> {/* Aggiunta della colonna Totale Ore */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Ore Lavorate</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].oreLavorate[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'oreLavorate', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].oreLavorate)}</TableCell> {/* Mostra il totale delle ore */}
                    </TableRow>
                    <TableRow>
                      <TableCell>Notturno</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].notturno[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'notturno', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].notturno)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Straordinari</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].straordinari[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'straordinari', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].straordinari)}</TableCell> {/* Mostra il totale delle ore */}
                    </TableRow>
                    <TableRow>
                      <TableCell>Straordinario Notturno</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].straordinarioNotturno[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'straordinarioNotturno', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].straordinarioNotturno)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Festivo</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].festivo[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'festivo', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].festivo)}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Ferie</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].ferie[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'ferie', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }} style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].ferie)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Festività Godute</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].festivitaGoduta[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'festivitaGoduta', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].festivitaGoduta)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Permessi</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].permessi[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'permessi', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }} style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].permessi)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Assenze</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].assenze[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'assenze', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].assenze)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Malattia</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].malattia[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'malattia', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }} style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].malattia)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Infortunio</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].infortunio[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'infortunio', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].infortunio)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Maternità</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].maternita[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'maternita', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].maternita)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Ore Viaggio</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].oreViaggio[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'oreViaggio', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].oreViaggio)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Flessibilità</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].flessibilita[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'flessibilita', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }}
                            style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].flessibilita)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Altri Eventi</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          <TextField
                            variant="outlined"
                            size="small"
                            placeholder=""
                            disabled={presenzeInviate}
                            value={presenze[tabVisualizzata].altriEventi[giorno - 1] || ''}
                            onChange={(e) => handleDipendenteChange(e, tabVisualizzata, 'altriEventi', giorno)}
                            InputProps={{ inputProps: { type: 'text', style: { padding: '4px', textAlign: 'center' } } }} style={{ width: '40px' }}
                          />
                        </TableCell>
                      ))}
                      <TableCell>{sumOre(presenze[tabVisualizzata].altriEventi)}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell>Totale Ore</TableCell>
                      {Array.from({ length: numGiorniMese }, (_, i) => i + 1).map((giorno) => (
                        <TableCell key={giorno}>
                          {calcolaTotaleGiornaliero(tabVisualizzata, giorno)}
                        </TableCell>
                      ))}
                      <TableCell>{calcolaTotale(tabVisualizzata)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <TextField
                variant="outlined"
                size="small"
                label="Note"
                disabled={presenzeInviate}
                value={note[tabVisualizzata]}
                onChange={(e) => handleNoteChange(e, tabVisualizzata)}
                style={{ marginTop: '12px', width: "100%" }}
                multiline
                rows={4}
              />
            </Box>
          </Paper>
        )}

        {/* Dialog Allega File */}
        <Dialog
          open={openFilesDialog}
          onClose={() => setOpenFilesDialog(false)}
          fullWidth
          maxWidth="xl"
          PaperProps={{ style: { borderRadius: '10px' } }}
        >
          <DialogTitle sx={{ marginBottom: 0 }}>
            File allegati alle presenze di {mesi[mese]}
          </DialogTitle>
          <DialogContentText sx={{ color: 'text.secondary', fontSize: 12, marginLeft: '24px', marginTop: '-10px' }}>
            I file caricati si riferiscono al mese di elaborazione per i tuoi dipendenti. Se hai bisogno di aggiungere precisazioni, inseriscile nelle note o nel nome del file.
          </DialogContentText>
          <DialogContent
            style={{
              height: '600px',
              overflowY: 'auto',
              scrollbarWidth: 'thin',
              scrollbarColor: 'transparent transparent',
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {!presenzeInviate && <Box display="flex" alignItems="center" justifyContent="flex-start" mb={1}>
                  <Typography variant="body1" fontWeight="bold" gutterBottom style={{ margin: '8px', color: 'gray' }}>
                    Aggiungi:
                  </Typography>
                  <Tooltip title="Carica Documenti">
                    <IconButton
                      component="label"
                      color="primary"
                      style={{ marginRight: "10px" }}
                    >
                      <UploadIcon />
                      <input
                        type="file"
                        hidden
                        onChange={handleFileUpload}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>}
                <TableContainer component={Paper} style={{ borderRadius: '10px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
                  <Table>
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#333' }}>
                        <TableCell
                          style={{ backgroundColor: '#333', fontWeight: 'bold', color: '#fff', textAlign: 'center' }}
                        >
                          Nome File
                        </TableCell>
                        <TableCell
                          style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}
                        >
                          Data Inserimento
                        </TableCell>
                        <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Azioni</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {presenzeFiles.map((file) => (
                        <TableRow key={file.id}>
                          <TableCell style={{ textAlign: 'center' }}>{file.name}</TableCell>
                          <TableCell style={{ textAlign: 'center' }}>{new Date(file.date).toLocaleDateString()}</TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            <Tooltip title="Visualizza">
                              <IconButton disabled={!file.name.endsWith('.pdf')} onClick={() => utils.cliOpenPdfInNewTab(file.id)} color="primary">
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Scarica">
                              <IconButton onClick={() => utils.cliDownload(file.id)} color="success">
                                <DownloadIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Elimina">
                              <IconButton disabled={presenzeInviate} onClick={() => handleFileDelete(file.id)} color="error">
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                      {presenzeFiles.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={3} align="center" style={{ textAlign: 'center' }}>
                            Nessun file caricato.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenFilesDialog(false)} color="primary">Chiudi</Button>
          </DialogActions>
        </Dialog>

        {/* Paper per il calcolo delle ore di entrata e uscita */}
        <Paper elevation={3} style={{ margin: '16px', width: '90vw' }}>
          <Box p={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
              Calcolatore Ore Lavorate
            </Typography>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              <Grid item>
                <TextField
                  label="Entrata"
                  variant="outlined"
                  placeholder="Orario di entrata (hh:mm)"
                  value={oraEntrata}
                  onChange={handleChangeOraEntrata}
                  size="small"
                />
              </Grid>

              <Grid item>
                <TextField
                  label="inizio pausa"
                  variant="outlined"
                  placeholder="Inizio pausa (hh:mm)"
                  value={oraInizioPausa}
                  onChange={handleChangeOraInizioPausa}
                  size="small"
                />
              </Grid>
              <Grid item>
                <TextField
                  label="fine pausa"
                  variant="outlined"
                  placeholder="Fine pausa (hh:mm)"
                  value={oraFinePausa}
                  onChange={handleChangeOraFinePausa}
                  size="small"
                />
              </Grid>

              <Grid item>
                <TextField
                  label="Uscita"
                  variant="outlined"
                  placeholder="Orario di uscita (hh:mm)"
                  value={oraUscita}
                  onChange={handleChangeOraUscita}
                  size="small"
                />
              </Grid>

              <Grid item>
                <TextField
                  label="Totale Ore"
                  variant="outlined"
                  placeholder="Totale Ore"
                  value={oreTotali}
                  size='small'
                  InputProps={{
                    style: { fontWeight: 'bold' }
                  }}
                  readOnly
                />
              </Grid>
            </Grid>
          </Box>
        </Paper>


      </div>)}

      {statusMessage && (
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            my: 1,
            mx: 2,
            flexGrow: 1,
            backgroundColor: isError ? "#e57373" : "#81c784",
            borderColor: isError ? "#d32f2f" : "#388e3c",
            color: "black",
          }}
          role="alert"
        >
          {statusMessage}
        </Paper>
      )}

      <Grid container justifyContent="center" spacing={1}>
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <Tooltip title="Salva le Modifiche">
            <Button
              sx={{ m: 0 }}
              color="primary"
              variant="contained"
              fullWidth
              onClick={() => confirm(false)}
              disabled={presenzeInviate}
            >
              {presenzeInviate ? "Inviate" : "Salva"}
            </Button>
          </Tooltip>
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={2}>
          <Tooltip title="Invia le Presenze solo se Complete">
            <Button
              sx={{ mb: 2 }}
              color="primary"
              variant="contained"
              fullWidth
              onClick={() => setOpenConfirm(true)}
              disabled={presenzeInviate}
            >
              {presenzeInviate ? "Inviate" : "Invia"}
            </Button>
          </Tooltip>
        </Grid>

        {/* Dialog invio presenze */}
        <Dialog
          open={openConfirm}
          onClose={() => setOpenConfirm(false)}
          aria-labelledby="alert-dialog-title1"
          aria-describedby="alert-dialog-description1"
        >
          <DialogTitle id="alert-dialog-title1">Conferma Inserimento Presenze</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description1">
              Una volta inviate, le presenze <strong style={{ color: 'red' }}>non potranno più essere modificate</strong>.
              Assicurati che le presenze di tutti i dipendenti per l'intero mese siano corrette
            </DialogContentText>

            <Typography color="error" sx={{ marginTop: '16px' }}>
              *Se vuoi solo salvare senza inviare, clicca "Annulla" qui e poi "Salva" nella schermata principale.
              Invia solo quando tutte le presenze sono complete per tutti i dipendenti.
            </Typography>

            {checkEmptyPresenze().length > 0 && (
              <Typography sx={{ marginTop: '16px', fontWeight: 'bold', color: 'black' }}>
                Attenzione i seguenti dipendenti hanno le presenze vuote:
                {checkEmptyPresenze().map((dipendente, index) => (
                  <div key={index}><strong>{dipendente}</strong></div>
                ))}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenConfirm(false)} color="primary">
              Annulla
            </Button>
            <Button onClick={() => confirm(true)} color="primary" autoFocus>
              Conferma
            </Button>
          </DialogActions>
        </Dialog>

      </Grid>

      <style>
        {`
    .MuiTableCell-root {
      padding: 3px;
      text-align: center;
    }
    .MuiTableCell-root:first-child {
      position: sticky;
      left: 0;
      z-index: 1;
      background-color: white; /* Colore di sfondo per la colonna fissa */
    }
  `}
      </style>
    </Box>
  );
};

export default TabellaPresenze;